export var API = {
    DOMAIN: process.env.RAZZLE_DOMAIN,
    BASE: '/api/website/v1',
    HOME_PAGE: '/home_page/',
    ABOUT_US: '/about_us/',
    WORKS: '/our_products/',
    TECHS: '/techs/',
    MEDIA: '/our_media/',
    MRESTATEINFOMAIN: '/mrinfo_main/',
    MRESTATEINTRO: '/mrinfo_0_100/',
    MRESTATEFEATURES: '/mrinfo_features/',
    MRESTATEMONETIZE: '/mrinfo_monetization/',
    SERVICES: '/our_services/',
    QUESTION: '/submit_question/'
};
